/* unplugin-vue-components disabled */import script from "./NegotiationFields.vue?vue&type=script&lang=ts&setup=true"
export * from "./NegotiationFields.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__